import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync } from "@fortawesome/pro-solid-svg-icons/faSync";

import Base from "Components/Base/Base";
import { Button } from "Components/Partials/Form";

import { Scopes } from "Services";
import SageSyncApi from "Services/Api/Sage/Sync";

class SageSync extends Base {
    /**
     * @var state
     * @type {{synced, working: boolean}}
     */
    state = {
        working: false,
        synced: !!this.props.item?.sage_id,
    };

    /**
     * @method handleSyncToSage
     * @return {Promise<void>}
     */
    handleSyncToSage = async () => {
        this.working();

        const { type, item } = this.props;
        const request = await SageSyncApi.create({
            type,
            id: item?.id,
        });

        if (request.status === 201) {
            this.toastSuccess('Item has been scheduled to sync');

            return this.setState({
                working: false,
                synced: true,
            });
        }

        this.defaultToastrError();
    };

    /**
     * @method render
     * @return {JSX.Element|null}
     */
    render () {
        const { working, synced } = this.state;
        if (!Scopes.has('sage.can-sync') || synced) {
            return null;
        }

        return (
            <Button
                onClick={this.handleSyncToSage}
            >
                <FontAwesomeIcon icon={faSync} spin={working} className="mr-1" />

                Sync to Sage
            </Button>
        );
    }
}

export default SageSync;
